import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import { adminMainUrl } from '../../../../Config';
import Select from "react-select";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { getCompanyBranch } from '../../../../Redux/action/Joborder/JoborderAction';
import { useDispatch, useSelector } from 'react-redux';

const JobOrderEditOffcanvas = ({ token, user_id, show, b64id, handleClose, loadingUnusedQuotationList, UnusedQuotationListError, UnusedQuotationList, loadingJobOrderEmployeeList, JobOrderEmployeeListError, JobOrderEmployeeList, JobOrderDetail, refresh }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [disableSubmit, setDisableSubmit] = useState(false);

    const [quotationOption, setQuotationOptions] = useState([]);
    const [loadingQuotation, setLoadingQuotation] = useState(false);

    const [branchOption, setBranchOption] = useState([]);
    const [loadingBranch, setLoadingBranch] = useState(false);

    const [companyName, setCompanyName] = useState("");


    useEffect(() => {
        if (loadingUnusedQuotationList) {
            setLoadingQuotation(true);
        } else {
            setLoadingQuotation(false);
        }

        if (UnusedQuotationList) {
            let arr = [];
            UnusedQuotationList.map((val) => arr.push({ value: val.id, label: val.ship_quotation_no }));
            setQuotationOptions(arr);
        }
    }, [loadingUnusedQuotationList, UnusedQuotationListError, UnusedQuotationList]);


    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [loadingEmployee, setLoadingEmployee] = useState([]);

    useEffect(() => {
        if (loadingJobOrderEmployeeList) {
            setLoadingEmployee(true);
        } else {
            setLoadingEmployee(false);
        }

        if (JobOrderEmployeeList) {
            let arr = [];
            JobOrderEmployeeList.map(val => { arr.push({ value: val.user_id, label: val.name }) });
            setEmployeeOptions(arr);
        }
    }, [loadingJobOrderEmployeeList, JobOrderEmployeeListError, JobOrderEmployeeList]);


    const {
        loadingJobOrderCompanyBranchList,
        JobOrderCompanyBranchList,
        JobOrderCompanyBranchListError
    } = useSelector(state => state.JoborderReducer);


    useEffect(() => {
        if (JobOrderCompanyBranchList) {
            let arr = [];
            JobOrderCompanyBranchList.map(v => arr.push({ value: v.id, label: v.branch_name }));
            setBranchOption(arr);
        }
    }, [JobOrderCompanyBranchList])

    const initialValues = {
        // trans_mode: "",
        // trans_type: "",
        quotation_id: "",
        customer_id: "",
        customer_branch_id: "",
        job_owner_id: "",
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                values.id = atob(b64id);
                axios.post(`${adminMainUrl}/api/jobOrder/update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refresh();
                            handleClose();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    const handleChangeCompanyBranch = (quotation_id) => {
        try {
            formik.setFieldValue("customer_id", "");
            formik.setFieldValue('branch_id', "");
            let config = { headers: { 'auth-token': token, 'user_id': user_id } };
            axios.get(`${adminMainUrl}/api/jobOrder/get-companydetails-on-quotation?quotation_id=${quotation_id}`, config)
                .then(response => {
                    if (response.status == 200) {
                        if (response.data) {
                            if (response.data.data) {
                                if (response.data.data.customer_data) {
                                    formik.setFieldValue('customer_id', response.data.data.customer_data.id);
                                    setCompanyName(`${response.data.data.customer_data?.name} ${response.data.data.customer_data?.alias ? `(${response.data.data.customer_data?.alias})` : ""} - ${response.data.data.customer_data?.customerType}`);
                                    if (response.data.data.customer_data?.customer_branch) {
                                        if (Array.isArray(response.data.data.customer_data?.customer_branch)) {
                                            let arr = [];
                                            response.data.data.customer_data?.customer_branch.map(val => arr.push({ value: val.id, label: val.branch_name }));
                                            setBranchOption(arr);
                                        } else {
                                            setBranchOption([]);
                                        }
                                    } else {
                                        setBranchOption([]);
                                    }
                                } else {
                                    setCompanyName("");
                                    formik.setFieldValue('customer_id', "");
                                    setBranchOption([]);
                                }
                            }
                        }
                    } else {
                        console.log(response.data.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
        } catch (error) {
            // toast.error(error.message);
            console.log(error.message);
        }
    }

    useEffect(() => {
        if (JobOrderDetail) {
            // if (JobOrderDetail.quotation_id) {
            //     handleChangeCompanyBranch(JobOrderDetail.quotation_id)
            // };

            if (JobOrderDetail.customer_id) {
                dispatch(getCompanyBranch(token, user_id, JobOrderDetail.customer_id));
            }
            formik.setFieldValue("trans_mode", JobOrderDetail?.trans_mode);
            formik.setFieldValue("trans_type", JobOrderDetail?.trans_type);
            formik.setFieldValue("customer_branch_id", Number(JobOrderDetail?.customer_branch_id));
            formik.setFieldValue("job_owner_id", JobOrderDetail?.job_owner_id ? `${JobOrderDetail?.job_owner_id}` : "");
        };
    }, [JobOrderDetail]);

    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement={"end"} name={"end"}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Edit Job Order</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                            {/* <div className="col-md-6 mt-2">
                                <div className='ms-2'>
                                    <label htmlFor="" className='form-label  mb-0'>
                                        Transport Mode
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <select
                                            className="form-control form-control-sm"
                                            name="trans_mode"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.trans_mode}
                                        >
                                            <option value="">-</option>
                                            <option value="Air">Air</option>
                                            <option value="Sea">Sea</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 mt-2">
                                <div className='ms-2'>
                                    <label htmlFor="" className='form-label  mb-0'>
                                        Transport Type
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <select
                                            className="form-control form-control-sm"
                                            name="trans_type"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.trans_type}
                                        >
                                            <option value="">-</option>
                                            <option value="Import">Import</option>
                                            <option value="Export">Export</option>
                                        </select>
                                    </div>
                                </div>
                            </div> */}


                            <div className="col-md-6 mt-2">
                                <div className='ms-2'>
                                    <label htmlFor="" className='form-label  mb-0'>
                                        Branch
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <Select
                                            className='mt-2 custom-selector'
                                            options={branchOption}
                                            name="customer_branch_id"
                                            onChange={option => {
                                                formik.setFieldValue('customer_branch_id', option.value);
                                            }}
                                            value={branchOption.find(option => option.value === formik.values.customer_branch_id) || null}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 mt-2">
                                <div className='ms-2 input_box_section'>
                                    <label htmlFor="" className='form-label  mb-0'>
                                        Job Owner
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <Select
                                            className='mt-2 custom-selector '
                                            options={employeeOptions}
                                            name="job_owner_id"
                                            onChange={option => {
                                                formik.setFieldValue('job_owner_id', option.value);
                                            }}
                                            value={employeeOptions.find(option => option.value === formik.values.job_owner_id) || null}
                                            isLoading={loadingEmployee}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-end">
                            <div className="col-md-6 d-flex justify-content-end">
                                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                    {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                                </button>
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default JobOrderEditOffcanvas